import { NotificationTypes } from 'uf/tasks/NotificationTypes';

export const exportLayer = {
  LAYER_EXPORT_STARTED: NotificationTypes.LAYER_EXPORT_STARTED,
  LAYER_EXPORT_DONE: NotificationTypes.LAYER_EXPORT_DONE,
  LAYER_EXPORT_ERROR: NotificationTypes.LAYER_EXPORT_ERROR,
} as const;
